/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Errorretry2Inputs */

const en_notificationcenter_errorretry2 = /** @type {(inputs: Notificationcenter_Errorretry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Notificationcenter_Errorretry2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_errorretry2 = /** @type {((inputs?: Notificationcenter_Errorretry2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Errorretry2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_errorretry2(inputs)
});
export { notificationcenter_errorretry2 as "notificationCenter_errorRetry" }